import {Injectable} from '@angular/core';
import {
    LearningChannel,
    LearningChannelType
} from '../../../../micromate-learn-lib/src/lib/components/profile/LearningChannel';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TeamsChannelDetectorService {
    private readonly channel: LearningChannelType;

    constructor() {
        const params = new URLSearchParams(window.location.search);
        const channel = params.get('channel');
        this.channel = channel === LearningChannel.MicrosoftTeamsTaskbase
            ? LearningChannel.MicrosoftTeamsTaskbase
            : LearningChannel.MicrosoftTeamsMicromate;
    }

    public detectTeamsChannel(): LearningChannelType {
        return this.channel;
    }

    public getMicrosoftTeamsChatChannelUrl(): string {
        const botId = this.channel === LearningChannel.MicrosoftTeamsTaskbase
            ? environment.taskbaseTeamsAppId
            : environment.micromateTeamsAppId;

        return `https://teams.microsoft.com/l/entity/${botId}/conversations`;
    }

}
